import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOPatientAllergies } from "../models/BOPatientAllergies.model";
import { BOTranspPatientAllergies } from "../models/auxiliars/BOTranspPatientAllergies.model";

@Injectable({
  providedIn: 'root'
}

)
export class PatientAllergiesService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/PatientAllergies/';

    constructor(private http:HttpClient){}
    //#region First

    getAllByPatientId(patientId:number):Observable<BOPatientAllergies[]>{
        return this.http.get<BOPatientAllergies[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    createOrUpdatePatientAllergies(transp:BOTranspPatientAllergies):Observable<BOPatientAllergies[]>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BOPatientAllergies[]>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientAllergies',body,httpOptions);
    }
    //#endregion First

//#region Single
  createOrUpdatePatientAllergiesSingle(patientId:number, disease:BOPatientAllergies):Observable<BOPatientAllergies>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOPatientAllergies>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientAllergiesSingle/' + patientId,body,httpOptions);
  }

deletePatientAllergiesSingle(id:number):Observable<BOPatientAllergies>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOPatientAllergies>(this.myAppUrl + this.myApiUrl + 'deletePatientAllergiesSingle/' + id,null,httpOptions);
    }


//#endregion Single

}
